'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp; // import { graphql, compose } from 'react-apollo';
// import gql from 'graphql-tag';
// import Typography from 'material-ui/Typography';
// import Grid from 'material-ui/Grid';
// import IconButton from 'material-ui/IconButton';
// import ConnectedIcon from 'material-ui-icons/SignalCellular4Bar';
// import DisconnectedIcon from 'material-ui-icons/SignalCellularNull';
// import { Link } from 'react-router-dom';
// import TextField from 'material-ui/TextField/TextField';
// import UserLink from '../../../../../modules/ui/User/Link';
// import Wallet from '../../Wallet';
// import Subscriber from './Subscriber';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UserMenuItem = (_temp = _class = function (_Component) {
  _inherits(UserMenuItem, _Component);

  function UserMenuItem() {
    _classCallCheck(this, UserMenuItem);

    return _possibleConstructorReturn(this, (UserMenuItem.__proto__ || Object.getPrototypeOf(UserMenuItem)).apply(this, arguments));
  }

  _createClass(UserMenuItem, [{
    key: 'render',
    // constructor(props) {
    //   super(props);
    //   this.state = {
    //   };
    // }
    // componentDidMount() {
    // }
    // static defaultProps = {
    // }
    value: function render() {
      var _props = this.props,
          user = _props.user,
          classes = _props.classes; // const {
      //   id,
      //   username,
      //   fullname,
      //   // firstname,
      //   // lastname,
      //   email,
      //   etherwallet,
      // } = user;
      // let connection;

      var UserLink = this.context.UserLink;

      var _ref = user || {},
          fullname = _ref.fullname,
          username = _ref.username;

      return _react2.default.createElement(UserLink, _extends({
        user: user,
        style: {
          marginLeft: 5
        },
        variant: null
      }, this.props), _react2.default.createElement(_Typography2.default, {
        className: classes.link
      }, fullname || username));
    }
  }]);

  return UserMenuItem;
}(_react.Component), _class.propTypes = {
  user: _propTypes2.default.object.isRequired,
  classes: _propTypes2.default.object.isRequired
}, _class.contextType = _context2.default, _temp);
exports.default = UserMenuItem;
module.exports = exports['default'];